import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userDecavitation } from '../../api';
import { useAlert } from '../useAlert';

export default function useUserDeactivation() {
  const { showAlert } = useAlert();
  const queryClient = useQueryClient();
  const memberDeleteRequest = useMutation({
    mutationFn: userDecavitation,
    mutationKey: 'userDecavitation',
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries('getUsers');
      showAlert({
        type: 'success',
        message: data?.message ?? 'Status changed sucessfully',
      });
    },
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      showAlert({ type: 'secondary', message: errMsg });
    },
  });
  return { ...memberDeleteRequest };
}
